import { Card } from 'antd';

function App(props) {
  return <Card bordered={false}>{props.children}</Card>;
}

export default App;
